import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FavoriteChip',
    props: {
        isFavorited: { type: Boolean },
        transparent: { type: Boolean },
        heartColour: { default: 'red' }
    },
    emits: ["favorite-clicked"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "2458c114": (props.transparent ? "transparent" : "#FFFFFF")
        }));
        const props = __props;
        const emit = __emit;
        function handleClick(event) {
            event.stopPropagation();
            event.preventDefault();
            emit('favorite-clicked', !props.isFavorited);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createBlock(_component_v_chip, {
                onClick: _withModifiers(handleClick, ["stop", "prevent"]),
                size: "x-small",
                class: "favoriteChip"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                        class: "heart",
                        icon: _ctx.isFavorited ? 'mdi-heart' : 'mdi-heart-outline',
                        style: _normalizeStyle(_ctx.isFavorited ? 'color: ' + _ctx.heartColour : '')
                    }, null, 8, ["icon", "style"])
                ]),
                _: 1
            }));
        };
    }
});
